import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { McpTool } from "../models/McpTool";

export const useSearchMcpTools = () => {
  const {
    data: mcpTools,
    call,
    isLoading,
    isFailed,
    setData: setMcpTools,
  } = useApiPrivateRequest<McpTool[]>((response) =>
    response.map((tool: any) => new McpTool(tool)),
  );

  const searchMcpTools = async (isEnabled?: boolean) => {
    const params = isEnabled !== undefined ? { isEnabled } : {};
    await call(`/llm/mcpTools/search`, "GET", params);
  };

  return {
    mcpTools,
    searchMcpTools,
    isLoading,
    isFailed,
    setMcpTools,
  };
};
